// extracted by mini-css-extract-plugin
module.exports = {"p381mkm":"p381mkm"};